import { render, staticRenderFns } from "./AbonosRetribuciones.vue?vue&type=template&id=3e2f413c&"
import script from "./AbonosRetribuciones.vue?vue&type=script&lang=js&"
export * from "./AbonosRetribuciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports